// export const API_URL = "http://localhost:5000/kai";
export const API_URL = "https://kamonnat-ai.com/kai";

export const APP_TITLE = "KMS";
export const FOOTER_TEXT = `${new Date().getFullYear()} Kamonnat-Ai`;
